import Script from "next/script";
import { IS_MOBILE } from "../../data/js/server-constants";
import { useRouterContext } from "../../contexts";

export const SellwildTv = (props) => {
  const { push } = useRouterContext()
  return  <div ref={(el) => {
    addSellwildTv(el, props, push)
  }} />
}

function addSellwildTv (element, { adUnit, ...rest }, push) {
  if (element && !element.innerHTML) {
    const tv = document.createElement("sellwild-tv");
    if (!IS_MOBILE) {
      tv.setAttribute("float", "true");
    }
    tv.setAttribute("videos", "https://cache.sellwild.com/playlists/main.json");
    tv.setAttribute("iu", "/21824729475/programatic-video")
    tv.setAttribute("ad-unit", `${JSON.stringify(adUnit)}`);
    tv.setAttribute("adType", 'Prebid');
    tv.setAttribute('adDisableDisplay', 'true');
    tv.setAttribute("width", "100%");
    tv.setAttribute("code", "sellwild");
    tv.setAttribute("targetBlank", "false");
    tv.setAttribute("baseUrl", "");
    Object.keys(rest).forEach(key => {
      tv.setAttribute(key, rest[key]);
    })
    tv.style.margin = 'auto';
    element.append(tv);

    element.addEventListener('click', (ev) => {
      if (ev.target instanceof HTMLElement) {
        const a = ev.target.closest('a')
        if (a) {
          const href = a.getAttribute('href')
          ev.preventDefault()
          push(href)

        }
      }
    })
  }
}

export const SellwildSellerTv = ({ userId: _userId }: { userId: string }) => {
  return null
  // return <SellwildTv userId={_userId} adUnit={adUnit} />
}

export const SellwildMainTv = (_props) => {
  return null
  // return <SellwildTv userId={""} adUnit={adUnit} {..._props} />
}

export const SellwildTvTag = () => {
  return (
    <>
      <link
        rel="stylesheet"
        href="https://widget.sellwild.com/static/css/v1_1_114/widget-tv.91dc61b8.css"
      />
      <Script
        async
        type="text/javascript"
        src="https://widget.sellwild.com/v1_1_114/widget-tv.js"
        id="sellwild-tv"
      />
      <style jsx global>{`
        sellwild-tv, .sellwild-tv-left h4, .sellwild-user h4 {
          font-family: "Avenir", sans-serif;
        }
        .sellwild-tv-left, .sellwild-tv-right {
          flex: 0;
        }
        .sellwild-tv-main video {
          object-fit: cover;
        }
        .sellwild-search input::placeholder {
          color: rgba(0,0,0,0.8)!important;
        }
        @media screen and (max-width: 520px) {
          .sellwild-tv-wrapper {
            height: 225px;
          }
          .STATE--product-open .sellwild-wrapper.corner:not(.closed) .sellwild-tv-main-container-inner {
            bottom: 64px;
          }
        }
      `}</style>
    </>
  );
};
